import _ from 'underscore';
import React, { useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { I18nContext } from '@bingads-webui-react/i18n-context';

import { getInsertInstructionStyle } from '../styles/insert-instruction-styles';

const InsertInstructionUnstyled = (props) => {
  const { classes } = props;
  const i18n = useContext(I18nContext);
  const stepList = useMemo(() => [
    _TL_('Click {0} below to copy the tracking tag to your clipboard.'),
    _TL_('Open the HTML for each page on your website.'),
    _TL_('Paste the tracking tag anywhere in the head section of your pages\' code (between the HTML "<head>" and "</head>" tags).'),
    _TL_('Make sure the tracking tag is in the code for every page of your website.'),
    _TL_('Save the changes to your webpages.'),
  ], []);
  const onRenderSteps = useMemo(() => _.map(stepList, (step, idx) => {
    const texts = i18n.getString(step).split('{0}');

    return (
      <li key={idx} className={`step-${idx}`}>
        {texts[0]}
        {texts.length === 2 &&
          <b>{i18n.getString(_TL_('Copy tag'))}</b>
        }
        {texts[1]}
      </li>
    );
  }), [stepList, i18n]);

  return (
    <div className={classNames(classes.container, 'insert-instruction')}>
      <ol className={classNames(classes.steps, 'insert-instruction-steps')}>
        {onRenderSteps}
      </ol>
    </div>
  );
};

InsertInstructionUnstyled.propTypes = {
  classes: PropTypes.shape(_.mapObject(
    getInsertInstructionStyle(),
    _.constant(PropTypes.string.isRequired)
  )).isRequired,
};

export const InsertInstruction = withDefaultStyles(InsertInstructionUnstyled, getInsertInstructionStyle);
